// ============================================================================
// GERMAN TRANSLATIONS - UNITY MODULE
// ============================================================================

export const unityTranslations = {
title: "Einheit, die Frieden bringt",
    author: "Von Emmanuel",
    subtitle: "Jede Religion hat ihre Gründe, unsere Grenzen kommen aus der Vergangenheit",
    description: "Modul zur Reflexion über spirituelle Einheit und Frieden zwischen den Traditionen",
    
    nav: {
      intro: "Einführung",
      religions: "Religionen",
      common: "Gemeinsame Grundlagen",
      humility: "Demut"
    },

    intro: {
      emmanuelSays: "Emmanuel sagt:",
      ourBordersFromPast: "Unsere Grenzen kommen aus der Vergangenheit",
      bordersDescription: "Jede Religion hat ihre Gründe. Unsere Spaltungen sind nicht Gottes Wille, sondern Früchte der Geschichte, Geographie, Kultur.",
      divisionWork: "Spaltung, Trennung durch Barrieren und Grenzen der Angst, ist das Werk unserer geföhrlichen Vergangenheit.",
      sharedHumanity: "Wir wurden in verschiedenen Traditionen geboren, aber wir teilen die gleiche Menschlichkeit.",
      
      revelationTitle: "Augen├Âffnende Offenbarung",
      surprisedLearning: "Ich war eines Tages überrascht zu erfahren, dass Juden auch Kinder Gottes sind.",
      angelMichael: "Dass der Erzengel Michael ein Hauptbote für Muslime ist.",
      jesusNames: "Dass Jesus, Isa, Jeschua auf verschiedene Weise bekannt sind, sogar im christlichen Glauben.",
      diverseTribes: "Denn es gibt verschiedene Stömme, verschiedene Kirchen, verschiedene Familien.",
      sameRealities: "Wir sprechen über die gleichen Realitöten mit verschiedenen Namen. Dies sollte uns nöher bringen, nicht spalten.",
      
      respectTitle: "Respekt: Grundlage der Demut, Hüter des Friedens",
      respectFoundation: "Auch wenn Brüderlichkeit in der Wahrheit nicht m├Âglich ist, ist Respekt die Grundlage der Demut, der Hüter des Friedens.",
      understandingProcess: "Andere Religionen zu verstehen und zu respektieren ist ein Prozess der Demut. Es bedeutet nicht, deinen Glauben aufzugeben, sondern zu akzeptieren, dass andere auch die Wahrheit suchen.",
      
      whatBindsUs: "Was uns wirklich verbindet",
      seekingRelation: "Jede Religion sucht eine Beziehung. Jeder sucht Frieden.",
      loveOfGod: "Diese Beziehung, die alle verbindet, ist die Liebe Gottes.",
      universalLink: "Liebe ist das universelle Band, das alle Grenzen, alle Sprachen, alle Traditionen überschreitet.",
      
      inclusionTitle: "Inklusion: Über religi├Âse Unterschiede hinaus",
      vastInclusion: "Religi├Âse Unterschiede sind gro├ƒ, aber darüber hinaus gibt es die Inklusion anderer, wo sie von Gott gerufen werden.",
      respectDifferences: "Respekt vor Unterschieden in Hautfarbe, Geschlecht, Inklusion macht uns zu einzigartigen Menschen, von Gott geliebt.",
      jesusCommand: "Jesus sagte: 'Liebt einander.'",
      
      communitySpirit: "Den Stammesgeist verlassen",
      communityTerror: "Stammestum ist der Terror des verborgenen Hasses des B├Âsen. Es verwandelt Glauben in Stammesidentitöt, in eine trennende Mauer, in eine verletzende Waffe.",
      pridePolitics: "Unsere Parteigeister treiben uns in die Politik des Stolzes:",
      prideQuotes: "Ich habe das Recht, dich zu verletzen. Ich habe nur recht. Ich habe das Recht, gerechte Kriege zu führen.",
      watchHeart: "Hüte dich vor dem Herzen des Problems, der Wurzel unseres eigenen Übels.",
      refuseDivision: "Lasst uns diese trennende Tendenz ablehnen, die die Menschheit im Namen Gottes spaltet.",
      
      freedomTitle: "Frei sein, andere frei machen",
      freedomOthers: "Um frei zu sein, müssen wir auch wissen, wie wir andere frei machen.",
      defendFreedom: "Meine Freiheit zu glauben hat nur dann Wert, wenn ich die Freiheit aller verteidige. Andere zu verurteilen bedeutet, sich selbst zur Sklaverei zu verurteilen.",
      
      changeHeartTitle: "Veröndere dein Herz: Sei ein echtes Licht",
      recognizeDecency: "Erkenne, dass Anstand nicht für alle gleich ist.",
      changeYourself: "Veröndere dich selbst zuerst, Schritt für Schritt. Veröndere dein Herz, verwandle dein Leben, sei ein echtes Licht.",
      beExample: "Uriniere nicht auf das Gras, denn es wird sterben... Setze deine Gesetze nicht anderen auf, sondern sei ein lebendiges Beispiel durch deine Verönderung.",
      
      childrenPeaceTitle: "Unsere Kinder werden in Vielfalt in Frieden leben",
      avoidPursuit: "Vermeide es, Worten Wort für Wort zu folgen.",
      peaceChoice: "Wenn wir heute Respekt wöhlen, werden unsere Kinder von morgen in Vielfalt in Frieden leben. Friede beginnt mit uns, jetzt, in unseren Worten und Taten.",
      
      discernTitle: "Unterscheide: Mensch oder Gott?",
      manSpeaks: "Oft ist es das Herz des Menschen, das spricht und spaltet.",
      seeFruits: "Wir sehen dies an den Früchten von Worten und Aussagen: Diebstahl, Zerst├Ârung, Kriege. Hüte dich vor der Töuschung von Worten, die um deinen eigenen Stolz konkurrieren.",
      
      lookPeaceTitle: "Schau mit Frieden und Liebe",
      lookPeaceAll: "Schau mit Frieden auf alle, schau mit Gottes Liebe auf andere.",
      godSpeaks: "Wenn Worte Frieden, Vers├Âhnung, Einheit bringen: Gott spricht. Wenn sie Spaltung, Hass, Kriege bringen: Es ist menschlicher Stolz.",
      
      watchWordsTitle: "Achte auf unsere Worte",
      watchShares: "Achte auf unsere Spaltungen, achte auf unsere scharfen Worte, die andere schödigen.",
      disqualify: "Diese Übel disqualifizieren uns. Die Früchte unserer Worte offenbaren, wer in uns spricht: Gott oder unser eigener Stolz?",
      
      wisdomMaturityTitle: "Weisheit und Reife vor unserer Natur",
      useScriptures: "Schriften (Gesetze) zu verwenden, um zu verletzen, ist unser Verhalten, ein fast natürlicher Prozess und Spiel.",
      hateSin: "Angesichts unserer sündigen Natur hassen wir das B├Âse und die Menschen, die B├Âses tun.",
      separateActs: "Aber mit Weisheit und Reife müssen wir Handlungen von unserer menschlichen Armseligkeit trennen.",
      compassionNature: "Unsere tierische Natur zu erkennen, die Mitgefühl und Gnade braucht, wöhrend wir uns je nach Kontext schützen.",
      
      denounceLeadersTitle: "Korrupte spirituelle Führer anprangern",
      watchLeaders: "Hüte dich vor spirituellen Führern oder Regierenden, die versuchen, ihre Ausrichtung und Töuschung zu verbergen.",
      noJustice: "Ohne Gerechtigkeit gibt es kein Beispiel. Ohne Wissen sterben andere Opfer in unserem Schweigen.",
      silenceComplicity: "Schweigen angesichts von Unterdrückung ist Komplizenschaft. Die Wahrheit muss gesprochen werden, um andere zu schützen."
    },

    religions: {
      title: "Verschiedene Religionen, eine Menschheit",
      intro: "Christen, Muslime, Juden, Hindus, Buddhisten... und viele andere: Alle suchen die Wahrheit",
      theirGod: "Ihr Gott:",
      theGood: "Das Gute:",
      theEvil: "Das B├Âse:",
      theAngels: "Die Engel:",
      theUnity: "Die Einheit:",
      values: "Werte:",
    commonGoal: "Gemeinsames Ziel",
    seekingPeace: "Alle Religionen teilen ein gemeinsames Ziel: Frieden suchen, Liebe fördern und eine bessere Welt aufbauen. Jenseits unserer Unterschiede sind wir alle in dieser Suche nach Weisheit und Harmonie vereint.",
      
      christianity: {
        name: "Christentum",
        godText: "Ein einziger Gott, Vater Sch├Âpfer",
        goodText: "Nöchstenliebe, Vergebung, Frieden",
        evilText: "Hass, Egoismus, Gewalt",
        angelsText: "Boten Gottes (Gabriel, Michael...)",
        unityText: "Ein Gott für alle Menschen",
        values: "Liebe,Vergebung,Frieden,Demut,Gerechtigkeit"
      },
      islam: {
        name: "Islam",
        godText: "Allah, der Einzige und Barmherzige",
        goodText: "Gerechtigkeit, Almosen, Frieden",
        evilText: "Unterdrückung, Lüge, Spaltung",
        angelsText: "Engel des Lichts (Jibril, Mikail...)",
        unityText: "Es gibt keinen Gott au├ƒer Allah",
        values: "Frieden,Gerechtigkeit,Almosen,Respekt,Barmherzigkeit"
      },
      judaism: {
        name: "Judentum",
        godText: "JHWH, der Einzige Ewige",
        goodText: "Gerechtigkeit, Barmherzigkeit, Leben",
        evilText: "Unterdrückung, G├Âtzendienst, Hass",
        angelsText: "Himmlische Boten (Malakhim)",
        unityText: "H├Âre Israel, der Ewige ist Eins",
        values: "Gerechtigkeit,Leben,Erinnerung,Frieden,Studium"
      },
      hinduism: {
        name: "Hinduismus",
        godText: "Brahman, die h├Âchste Wahrheit",
        goodText: "Gewaltlosigkeit (Ahimsa), gerechte Pflicht",
        evilText: "Gewalt, spirituelle Unwissenheit",
        angelsText: "Devas, gute himmlische Wesen",
        unityText: "Alles ist Eins in Brahman",
        values: "Gewaltlosigkeit,Wahrheit,Mitgefühl,Reinheit,Hingabe"
      },
      buddhism: {
        name: "Buddhismus",
        godText: "Kein Sch├Âpfergott, aber Respekt für das Heilige",
        goodText: "Mitgefühl, Weisheit, Frieden",
        evilText: "Leiden, verursacht durch Unwissenheit",
        angelsText: "Bodhisattvas, erwachte Wesen",
        unityText: "Buddha-Natur in jedem",
        values: "Mitgefühl,Weisheit,Frieden,Gewaltlosigkeit,Erwachen"
      }
    },

    common: {
      title: "Gemeinsame Grundlagen",
      intro: "Das Gute, das B├Âse, die Engel, der Eine Gott, Beziehung, Inklusion: Was die Menschheit verbindet",
      
      goodTitle: "Das Gute",
      goodDescription: "Alle Religionen lehren Liebe, Gerechtigkeit und Mitgefühl",
      goodExamples: "Liebe deinen Nöchsten wie dich selbst|Tue Gutes ohne Unterscheidung|Schütze die Schwachen und Unterdrückten|Sprich die Wahrheit mit Güte|Teile, was du hast",
      
      evilTitle: "Das B├Âse",
      evilDescription: "Alle lehnen Gewalt, Lüge und Unterdrückung ab",
      evilExamples: "Ungerechtes T├Âten|Stehlen und Ausbeuten|Lügen und Betrügen|Verachten und Erniedrigen|Spalten und Hassen",
      
      angelsTitle: "Engel und Spirituelle Wesen",
      angelsDescription: "Fast alle erkennen gute himmlische Boten an",
      angelsExamples: "Engel, Boten Gottes|Spirituelle Führer|Lichtwesen|Himmlische Wöchter|Bodhisattvas und Devas",
      
      godTitle: "Ein Gott (oder H├Âchste Wahrheit)",
      godDescription: "Viele glauben an eine Quelle, einen Sch├Âpfer oder eine endgültige Wahrheit",
      godExamples: "Christentum, Islam, Judentum: Ein Gott|Hinduismus: Brahman, das h├Âchste Eine|Buddhismus: Universelle Buddha-Natur|Alle suchen die endgültige Wahrheit|Alle streben nach Einheit und Frieden",
      
      relationTitle: "Beziehung und Frieden",
      relationDescription: "Was wirklich alle Religionen und alle Menschen verbindet",
      relationExamples: "Jede Religion sucht eine Beziehung mit dem G├Âttlichen|Jeder sucht Frieden|Diese Beziehung, die alle verbindet, ist die Liebe Gottes|Liebe ist das universelle Band|Friede ist unsere gemeinsame Sehnsucht",
      
      inclusionTitle: "Inklusion: Von Gott Geliebt",
      inclusionDescription: "Religi├Âse Unterschiede sind gro├ƒ, aber Inklusion ist gr├Â├ƒer",
      inclusionExamples: "Inklusion anderer, wo sie von Gott gerufen werden|Respekt vor Unterschieden in der Hautfarbe|Respekt vor Geschlechtsunterschieden|Inklusion macht uns zu einzigartigen Menschen, von Gott geliebt|Jesus sagte: 'Liebt einander'",
      
      finalQuote: "Ich war eines Tages überrascht zu erfahren, dass Juden auch Kinder Gottes sind, dass der Erzengel Michael ein Hauptbote für Muslime ist, dass Jesus, Isa, Jeschua auf verschiedene Weise bekannt sind, sogar im christlichen Glauben. Denn es gibt verschiedene Stömme, verschiedene Kirchen, verschiedene Familien.",
      finalQuote2: "Wir sprechen über die gleichen Realitöten mit verschiedenen Namen.",
      quoteAuthor: "Emmanuel, Einheit, die Frieden bringt"
    },

    humility: {
      title: "7 Schritte zu Demut und Frieden",
      intro: "Ein Prozess, um Stammestum zu überwinden und ein echtes Licht zu werden",
      
      step: "Schritt",
      action: "Handlung:",
      
      step1Title: "Erkennen: Unsere Grenzen kommen aus der Vergangenheit",
      step1Description: "Spaltung, Trennung durch Barrieren und Grenzen der Angst, ist das Werk unserer geföhrlichen Vergangenheit. Unsere Spaltungen sind nicht Gottes Wille.",
      step1Action: "Akzeptieren, dass meine Tradition nur meine ist, und ich Teil der von Gott gewünschten Vielfalt bin",
      
      step2Title: "Respekt: Grundlage der Demut, Hüter des Friedens",
      step2Description: "Auch wenn Brüderlichkeit in der Wahrheit nicht m├Âglich ist, ist Respekt die Grundlage.",
      step2Action: "Alle Glaubensrichtungen respektieren, auch ohne alles zu verstehen",
      
      step3Title: "Verstehen ohne zu urteilen",
      step3Description: "Heute ist es wichtig, andere in einem Prozess der Demut zu verstehen.",
      step3Action: "Wirklich zuh├Âren, was andere glauben, ohne zu urteilen",
      
      step4Title: "Veröndere dich selbst zuerst: Sei ein echtes Licht",
      step4Description: "Erkenne, dass Anstand nicht für alle gleich ist. Veröndere dein Herz Schritt für Schritt, verwandle dein Leben, sei ein echtes Licht.",
      step4Action: "Meine Gesetze nicht anderen auferlegen, sondern ein lebendiges Beispiel durch meine Verönderung sein",
      
      step5Title: "Den Stammesgeist verlassen",
      step5Description: "Unsere Parteigeister treiben uns in die Politik des Stolzes: 'Ich habe das Recht, dich zu verletzen, ich habe nur recht.' Hüte dich vor dem Herzen des Problems, der Wurzel unseres eigenen Übels.",
      step5Action: "Spaltende Reden in meiner eigenen Gemeinschaft ablehnen",
      
      step6Title: "Frei sein, andere frei machen",
      step6Description: "Meine Freiheit höngt von der ab, die ich anderen gebe.",
      step6Action: "Die Gewissensfreiheit aller verteidigen, nicht nur meine",
      
      step7Title: "Vermeide es, Worten Wort für Wort zu folgen",
      step7Description: "Nicht auf Hass mit Hass antworten, auf Beleidigungen mit Beleidigungen.",
      step7Action: "Frieden wöhlen, damit unsere Kinder in Vielfalt in Frieden leben",
      
      discernFruits: "Unterscheide durch die Früchte",
      humanHeart: "Das menschliche Herz, das spaltet",
      lookGodLove: "Schau mit Gottes Liebe",
      watchOurWords: "Achte auf unsere Worte",
      
      prideFruits: "Früchte des menschlichen Stolzes",
      prideFruitsList: "Parteigeist: \"Ich habe recht, Punkt\"|Politik des Stolzes: \"Ich habe recht, dir wehzutun\"|Schriften benutzen, um zu verletzen (schelmischer Prozess)|Personen hassen (nicht nur Taten)|Geistliche Führer, die ihre Abweichung und Unehrlichkeit verbergen|Komplizenhaftes Schweigen angesichts von Ungerechtigkeit|Spaltung und Kriege|Hass, getarnt als Frömmigkeit|Diebstahl und Zerstörung|Manipulation für Stolz|Verachtung und Gewalt",
      
      godFruits: "Früchte der Liebe Gottes",
      godFruitsList: "Taten von Person mit Weisheit trennen|Mitgefühl für unsere menschliche Armut|Gnade, während wir uns je nach Kontext schützen|Ungerechtigkeit anprangern, um andere zu schützen|Wahrheit mit Mut sprechen|Frieden für alle|Liebe ohne Unterscheidung|Versöhnung und Einheit|Demut und Respekt|Freiheit für alle",
      
      finalQuote: "Auch wenn Brüderlichkeit in der Wahrheit nicht m├Âglich ist, ist Respekt die Grundlage der Demut, der Hüter des Friedens. Vermeide es, Worten Wort für Wort zu folgen, und unsere Kinder von morgen werden in Vielfalt in Frieden leben.",
      author: "Emmanuel"
    },

    footer: {
      quote: "Respekt ist die Grundlage der Demut, der Hüter des Friedens. Unsere Kinder werden in Vielfalt in Frieden leben, wenn wir heute Respekt wöhlen.",
      author: "Emmanuel, Einheit, die Frieden bringt"
    }
};

export default unityTranslations;
